<template>
    <div :style="indent" class="tree2ItemContainer" 
            >
       <!--  <div v-show="children.length" class="treeExpander2" style="cursor: pointer" @click="doExpand">{{ isExpanded ? '&nbsp;- ' : ' + ' }}</div>
        <div v-show="!children.length" class="treeExpander2">&nbsp;</div> -->
        <!-- <input ref="cb" type="checkbox" @click="clicked" :checked="isSelected"/> -->
        <div  class="is-inline">
            
            <div class="left5 handCursor">
                <div ><span class="has-text-weight-normal pageLabel" @click="selectPage(item.id)"><b><span v-show="item.isLanding" class="has-text-coolGreen">&bull; </span>{{item.name}}</b></span>
                    &nbsp;<img v-show="!inHelp" src="@/assets/img/pencil.png" width="12" class="handCursor" @click="editPage(item)"  /></div>
            </div>

        </div>
            <helpTree  v-for="(item, ind4) in item.children" 
                :key="ind4" 
                :item="item" 
                :depth="depth + 1" 
                :inHelp="inHelp"
                >
          </helpTree>
    </div>
</template>

<script>
    import { AZEventBus } from './AZEventBus'


    export default { 
        name: 'helpTree',
        props: ['item', 'depth', 'inHelp'],
        data: function(){
            return {
               
            }
        },
        created(){
           
            //if(this.depth > 0)
                //this.path.push({id: this.id, listName: this.listName})
              
        },
      /*   beforeDestroy: function(){
            AZEventBus.$off('pageSelected', {id: id})
         }, */

        methods: {
        
            selectPage: function(id){
                if(!this.inHelp){
                    AZEventBus.$emit('pageSelected', {id: id, name: this.item.name, isLanding: this.item.isLanding, code: this.item.code})
                } else {
                    if(this.$route.path.split('/accsettings').length > 1)
                        this.$router.push(`/accsettings/help/` + this.item.code ? this.item.come : id)
                    else if(this.$route.path.split('/info').length > 1)
                        this.$router.push(`/info/help/` + this.item.code ? this.item.come : id)
                }
            },
            editPage: function(obj){
                var index = -1
                var isLanding = this.item.isLanding
                this.$root.app.doShowModal('modalNewPage', {createOrEdit: 'edit', item: obj, isLanding: isLanding ? 1:0, index: index, tree: this.$root.app.$refs.routerView.tree})
            },
        },
        computed: {
            indent() {
                return this.depth == 0 ? '' : { 'margin-left': '15px' }//transform: 'translate(20px)'
            }
        }
    }
</script>